import moment from 'moment';
import api from '../../config/index'

const loanHistory = async () => {
    const response = await api.get('Loan/fetch-staff-loan-history');
    return response?.data;
}

const loanApplication = async (loanDetails) => {
    const response = await api.post('Loan/PostEmployeeLoanDetails', loanDetails);
    return response.data;
}

const getDSCR = async (loanReference) => {
  const response = await api.get(`Loan/GetDSCRComputation/${loanReference}`)
  return response?.data
}

const rejectLoan =  async (params) => {
    const response = await api.post('Loan/GetLoanAcceptability', params)
    return response?.data
}

const loanCount = async (loanNumber) => {
  const response = await api.get(`admin/loan/admin-loan-approval-count?approvalStatus=${loanNumber}`)
  return response?.data
}

const authoriserPending  = async (pageSize) => {
    const response = await api.get(`admin/loan/authorizer-admin-loans?PageNumber=1&PageSize=${pageSize}`)
    return response?.data
}

const checkEmptyDate = (loanNumber:number, pageSize, startDate:string, endDate:string, pageValues:string, loanTypes:string, searchValues:string) => {
    if(startDate === '' && endDate === '') return `admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}`
    else if (endDate === '') return `admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}&startDate=${startDate}&endDate=${moment(startDate).add(1, 'd').format('YYYY-MM-DD')}`
    return `admin/loan/loan-status?status=${loanNumber}&PageNumber=${pageValues}&PageSize=${pageSize}&loanType=${loanTypes}&searchString=${searchValues}&startDate=${startDate}&endDate=${endDate}`
  }


  export const getFilteredLoans = (loanNumber, pageSize, pageValues, searchValues, loanTypes, 
    setCurrentItems, setLoading, endDate, startDate) => {
      setLoading(true)
      return api
      .get(checkEmptyDate(loanNumber, pageSize, startDate, endDate, pageValues, loanTypes, searchValues), {
       
      }).then((res) =>{ setLoading(false);
        if(res?.data?.data?.length === 0)setCurrentItems([])
        setCurrentItems(res?.data?.data);
        // if(loanNumber === 8)setCurrentItems(res?.data?.data?.filter(loan => loan?.vendorDetailStatus ==='Invalid Vendor Details')); 
      })
     
  }
  
  const getPendingLoans = (pendingLoanNumber) => {
    const response:any  = api.get(`/admin/loan/loan-status?status=${pendingLoanNumber}`)
    return response?.data
  }

  const approveLoans = async (loanInfo) => {
    const respose:any = await api.post(`admin/loan/update-loan-approval-status`, loanInfo)
    return respose?.data
  }

  const sendVendorDetails = async(vendorDetails) => {
    const response:any = await api.post(`Loan/add-vendor-details`, vendorDetails)
    return response?.data
  }

  const userLoanAcceptance = async (loanRef) => {
    const response:any = await api.post(`Loan/send-otp/?loanRef=${loanRef}`)
    return response?.data
  }

  const sendOTP = async (otpInfo) => {
    const response:any = await api.post(`Loan/ValidateOtp`, otpInfo)
    return response?.data
  }

const LoanService = {
    loanHistory,
    loanApplication,
    getDSCR,
    rejectLoan,
    loanCount,
    authoriserPending,
    getFilteredLoans,
    getPendingLoans,
    approveLoans,
    sendVendorDetails,
    userLoanAcceptance,
    sendOTP
}

export default LoanService;